import React, { useState, useEffect, useLayoutEffect } from 'react';

import { Row, Col, Tabs, Input } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { FiSearch } from 'react-icons/fi';
import _ from 'lodash';
import { Navbar } from '../layout/Header';
import { useTranslation } from 'react-i18next';
import { EmptyContainer } from '../layout/EmptyContainer';

import { getUserState } from '../../store/user/selector';
import { getOrderState } from '../../store/orders/selector';
import { getOrders } from '../../store/orders/actions';
import { setLoading } from '../../store/app-globals/actions';

import ListIcon from '../../assets/images/png/list.png';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { LastOrders } from './components/PastOrders';
import { NewOrders, orderTimeDifference } from './components/CurrentOrders';
import { OrdersLoading } from '../chat/components/Loading';
import { getAppGlobalState } from '../../store/app-globals/selectors';

export const CurrentOrders: React.FC = () => {
  const history: History = useHistory();
  const { user } = useSelector(getUserState);
  const { orders } = useSelector(getOrderState);
  const [width, setWidth] = useState<number>(0);
  const { accountType } = user;
  const isGuest = accountType === 'i seek';
  const { t } = useTranslation();
  const filterOrders = _.filter(
    orders,
    order =>
      order.status === 'waiting' || !orderTimeDifference(order.consumptiondate)
  );
  console.log(filterOrders);
  const handleButtonClick = () => {
    history.push('/dashboard');
  };
  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  const isDesktop = width >= 768;
  return (
    <Row justify="center" className="neworder-container">
      {filterOrders.length > 0 ? (
        <div
          className={
            isDesktop
              ? 'current-order-grid-display neworder-container'
              : 'neworder-container'
          }
        >
          {filterOrders.map((item, i) => (
            <Col key={i}>
              <NewOrders isGuest={isGuest} meal={item} />
            </Col>
          ))}
        </div>
      ) : (
        <EmptyContainer
          title={t('Currently you have no orders')}
          icon={ListIcon}
          onClick={isGuest ? handleButtonClick : undefined}
        />
      )}
    </Row>
  );
};

export const PastOrders: React.FC = () => {
  const { orders } = useSelector(getOrderState);
  const { user } = useSelector(getUserState);
  const { accountType } = user;
  const isGuest = accountType === 'i seek';
  const [neworders, setNewOrders] = useState(orders);
  const [filterorders, setFilterOrders] = useState(orders);
  const { t } = useTranslation();
  const filterPastOrder = () => {
    const filterorder = _.filter(
      orders,
      order =>
        order.status === 'accepted' &&
        orderTimeDifference(order.consumptiondate)
    );
    setNewOrders(filterorder);
    setFilterOrders(filterorder);
  };

  useEffect(filterPastOrder, []);
  const handleFieldChange = (e: React.FormEvent<HTMLInputElement>) => {
    const matchText = e.currentTarget.value
      .replace(/[^a-zA-Z0-9+]/g, ' ')
      .toLocaleLowerCase();
    // console.log(matchText);
    const matchOrder = filterorders.filter(order =>
      order.title.toLocaleLowerCase().match(matchText)
    );
    setNewOrders(matchOrder);
  };
  return (
    <Row justify="center" className="neworder-container">
      {filterorders.length > 0 ? (
        <div className="neworder-container">
          <Row className="search-container">
            <Col span={24}>
              <Input
                size="large"
                placeholder="Search..."
                prefix={<FiSearch color="#939393" size={20} />}
                className="input-search"
                onChange={handleFieldChange}
              />
            </Col>
          </Row>
          {neworders.map((item, i) => (
            <Col key={i}>
              <LastOrders meal={item} isGuest={isGuest} />
            </Col>
          ))}
        </div>
      ) : (
        <EmptyContainer
          title={t('Currently you have no past orders')}
          icon={ListIcon}
        />
      )}
    </Row>
  );
};

export const Orders: React.FC = () => {
  const history: History = useHistory();
  const { user } = useSelector(getUserState);
  const { isLoading } = useSelector(getAppGlobalState);
  const { t } = useTranslation();
  const { accountType } = user;
  const isGuest = accountType === 'i seek';
  const isCook = accountType === 'i offer';
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true, 'Fetching Chat List'));
    dispatch(getOrders());
  }, [dispatch, isGuest, isCook, history]);
  const onTabChange = (key: string) => {
    // console.log(key);
  };
  return (
    <div className="dashboard">
      <Row justify="center">
        <Navbar />
      </Row>
      <Row justify="center" className="orders-container">
        <Col xs={24} sm={24} md={24} lg={24} className="order-tabs">
          <Tabs
            defaultActiveKey="1"
            onChange={onTabChange}
            className="order-tabs-container"
            size="large"
          >
            <Tabs.TabPane tab={t('Current Orders')} key="1">
              {isLoading ? <OrdersLoading /> : <CurrentOrders />}
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Past Orders')} key="2">
              {isLoading ? <OrdersLoading /> : <PastOrders />}
            </Tabs.TabPane>
          </Tabs>
        </Col>
      </Row>
    </div>
  );
};
